module.exports = __webpack_public_path__ + "static/media/pdf.7e59491c.svg";